export default __webpack_public_path__ + "static/media/Parisienne-Regular.7a6f750f.ttf";